import { createReducer } from 'redux-act';
import { useSelector } from 'react-redux';
import { PARTNER_SOURCES } from '../../constants/partners';
import { IGlobalState } from '../index';

export interface IState {
    partnerSource?: ValuesOf<typeof PARTNER_SOURCES>;
}

const initialState: IState = {};

export const whitelabelReducer = createReducer({}, initialState);

export function useWhitelabelState() {
    return useSelector((state: IGlobalState) => state.whitelabel);
}
